import "core-js/stable";
import "regenerator-runtime/runtime";
import 'fast-text-encoding';
import 'webcrypto-shim';

import { TextEncoder } from 'text-encoding';
if (typeof window != 'undefined' && typeof window.TextEncoder !== 'undefined') {
  window.TextEncoder = TextEncoder;
}

if (!Uint8Array.prototype.slice) {
  Object.defineProperty(Uint8Array.prototype, 'slice', {
    value: function (begin, end) {
      return new Uint8Array(Array.prototype.slice.call(this, begin, end));
    },
  });
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
if (!String.prototype.includes) {
  String.prototype.includes = function (search, start) {
    'use strict';

    if (search instanceof RegExp) {
      throw TypeError('first argument must not be a RegExp');
    }
    if (start === undefined) {
      start = 0;
    }
    return this.indexOf(search, start) !== -1;
  };
}
